import React from 'react'
import NotLoadReports from './NotLoadReports/NotLoadReports'
import LoadReports from './LoadReports/LoadReports'
import LockerStatusReports from './LockerStatusReports/LockerStatusReports'
import NotOnloadReports from './NotOnloadReports/NotOnloadReports'
import OnloadReports from './OnloadReports/OnloadReports'
import UsedGeneralPasswordReports from './UsedGeneralPasswordReports/UsedGeneralPasswordReports'
import NotUsedGeneralPasswordReports from './NotUsedGeneralPasswordReports/NotUsedGeneralPasswordReports'
import LockerReports from './LockerReports/LockerReports'
import LockerAndBoxesReports from './LockerAndBoxesReports/LockerAndBoxesReports'
import OrderPasswordReports from './OrderPasswordReports/OrderPasswordReports'
import OrderPasswordDetailReports from './OrderPasswordDetailReports/OrderPasswordDetailReports'
import Tab from '../../components/UI/OrderTabbedPanel/TabbedPanel'

const Reports = (props) => {
    const prmsn = window.localStorage.getItem("permission");
    const tabs = prmsn.split(",").includes("CUSTOMER_WRITE") ?
        [
            {
                index: 0,
                label: "پر شده",
                value: <LoadReports />
            },
            {
                index: 1,
                label: "پر نشده",
                value: <NotLoadReports />
            },
            {
                index: 2,
                label: "خالی شده",
                value: <OnloadReports />
            },
            {
                index: 3,
                label: "خالی نشده",
                value: <NotOnloadReports />
            },
            {
                index: 4,
                label: "تخلیه شده",
                value: <UsedGeneralPasswordReports />
            },
            {
                index: 5,
                label: "تخلیه نشده",
                value: <NotUsedGeneralPasswordReports />
            },

        ] :
        [
            {
                index: 0,
                label: "پر شده",
                value: <LoadReports />
            },
            {
                index: 1,
                label: "پر نشده",
                value: <NotLoadReports />
            },
            {
                index: 2,
                label: "خالی شده",
                value: <OnloadReports />
            },
            {
                index: 3,
                label: "خالی نشده",
                value: <NotOnloadReports />
            },
            {
                index: 4,
                label: "تخلیه شده",
                value: <UsedGeneralPasswordReports />
            },
            {
                index: 5,
                label: "تخلیه نشده",
                value: <NotUsedGeneralPasswordReports />
            },
            {
                index: 6,
                label: "گزارش لاکر ها",
                value: <LockerReports />
            },
            {
                index: 7,
                label: "رزرو لاکرها و باکس",
                value: <LockerAndBoxesReports />
            },
            {
                index: 8,
                label: "وضعيت باکس لاکر",
                value: <LockerStatusReports />
            },
            {
                index: 9,
                label: "کدهای صادر شده",
                value: <OrderPasswordReports />
            },
            {
                index: 10,
                label: "جزئیات کدها",
                value: <OrderPasswordDetailReports />
            },
        ]
    return (
        <Tab tabs={tabs} />
    )
}

export default Reports